import request from '../../api/request';
const intelligenceStore = {
    namespaced: true,
    state: {
        listsIndex: 0, // 分类选择下标
        lists: [], // 分类
        historyList: [], // 历史记录
        allBotList: [], // 所有列表
    },
    getters: {},
    mutations: {
        handleIndex(state, playload) {
            state.listsIndex = playload || 0;
        },
        setNav(state, playload) {
            state.lists = [];
            let datas = [];
            Array.from({ length: 15 }).forEach((_, index) => {
                datas.push({});
            });
            Array.isArray(playload) && playload.forEach((el) => {
                el.menuId > 2 && state.lists.push({
                    ...el,
                    lists: datas,
                    loading: 'loading'
                });
            });
        },
        setLists(state, playload) {
            let indexs = !state.listsIndex ? state.listsIndex : JSON.parse(JSON.stringify(state.listsIndex));
            setTimeout(() => {
                state.lists[indexs].lists = playload;
                state.lists[indexs].loading = 'complete';
            }, 1000);
        }
    },
    actions: {
        getNav({ state, commit, dispatch }, playload) {
            if (state.lists.length > 0)
                return;
            return new Promise((resolve, reject) => {
                request.post('/app-api/lt/ai/menu/getList', {}).then((res) => {
                    resolve(res);
                    commit('setNav', res.data);
                    dispatch('intelligence/getLists', '', { root: true });
                }).catch((err) => {
                    reject(err);
                });
            });
        },
        getLists({ state, commit }, playload) {
            return new Promise((resolve, reject) => {
                var _a;
                let indexs = !state.listsIndex ? state.listsIndex : JSON.parse(JSON.stringify(state.listsIndex));
                request.post('/app-api/lt/ai/menu/getCatDetailList', {
                    menuCatId: ((_a = state.lists[indexs]) === null || _a === void 0 ? void 0 : _a.id) || ''
                }).then((res) => {
                    resolve(res);
                    commit('setLists', res === null || res === void 0 ? void 0 : res.data);
                }).catch((err) => {
                    reject(err);
                });
            });
        },
        getHistoryList({ state, commit }, playload) {
            return new Promise((resolve, reject) => {
                request.post('/app-api/lt/ai/chat/conversation/bot-list', {}).then((res) => {
                    state.historyList = res === null || res === void 0 ? void 0 : res.data;
                    resolve(res);
                }).catch((err) => {
                    reject(err);
                });
            });
        },
        getAllList({ state, commit }, playload) {
            return new Promise((resolve, reject) => {
                request.post('/app-api/lt/ai/menu/getCatDetailList', {}).then((res) => {
                    state.allBotList = res === null || res === void 0 ? void 0 : res.data;
                    resolve(res);
                }).catch((err) => {
                    reject(err);
                });
            });
        }
    },
    modules: {}
};
export default intelligenceStore;
